import App from "./App.vue";
import Vue from 'vue';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import { installRequestStatus } from "@/shared/request-status";

Vue.use(VueMaterial);
installRequestStatus();

new Vue({ render: createElement => createElement(App) }).$mount('#app');
